import { render, staticRenderFns } from "./ProductExtrasInput.vue?vue&type=template&id=02b9de8e&"
import script from "./ProductExtrasInput.vue?vue&type=script&lang=ts&"
export * from "./ProductExtrasInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports